import React, { Fragment, useContext } from 'react';
import { Helmet } from 'react-helmet';
import LocaleContext from '../../../../common/context/locale';
import { format } from 'date-fns';
import NewsletterSignUp from '../../../../common/components/forms/NewsletterSignUp.js';

import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header, Eyebrow } from 'formlabs-web-components/Type';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import Card from '../../../../common/components/content/Card';
import BlogPagination from './BlogPagination';
import './Blog.module.css';
const BlogPostList = ({
  posts,
  page,
  children,
  classes,
  hasNext,
  hasPrev,
  path,
  t
}) => {
  const { dateLocale } = useContext(LocaleContext);
  const localizeDate = date => {
    return format(new Date(date), 'MMM dd', {
      locale: dateLocale
    });
  };
  return (
    <Grid direction="x">
      {page > 1 ? (
        <Helmet>
          <link rel="canonical" href={`${path}?page=${page}`} />
        </Helmet>
      ) : null}
      <Cell largeSize={24}>
        <div styleName="filter-posts" className={classes} />
      </Cell>
      <Cell largeSize={children ? 16 : 24}>
        <div styleName="posts">
          {posts.map(post => {
            return (
              <Card
                key={`${post.title}${post.slug}`}
                url={post.url}
                imageConstraint="30%"
                imagePosition="left"
                bgColor="transparent-black"
                image={post.smallListingImage}
                padding="50px 35px"
                internalPadding="none"
                hover="light-grey"
                borderTopBottom={true}
                collapseBorder={true}
              >
                <div styleName="post-eyebrows">
                  <Eyebrow color="blue">{post.type}</Eyebrow>
                  <Eyebrow color="medium-grey">
                    {localizeDate(post.pub_date)}
                  </Eyebrow>
                </div>
                <Header level={4} displayAs={4} weight={400}>
                  {post.title}
                </Header>
              </Card>
            );
          })}
        </div>
        <BlogPagination page={page} hasNext={hasNext} hasPrev={hasPrev} />
      </Cell>
      {children && (
        <Cell largeSize={8} backgroundColor="light-grey">
          <div styleName="sidebar">
            <Fragment>
              <NewsletterSignUp layoutType="sidebar" />
            </Fragment>
            <Fragment>{children}</Fragment>
          </div>
        </Cell>
      )}
    </Grid>
  );
};

export default DisplayComponent(BlogPostList);
